import { render, staticRenderFns } from "./DashboardEditor.vue?vue&type=template&id=31401351&scoped=true&"
import script from "./DashboardEditor.vue?vue&type=script&lang=js&"
export * from "./DashboardEditor.vue?vue&type=script&lang=js&"
import style0 from "./DashboardEditor.vue?vue&type=style&index=0&id=31401351&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31401351",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VRow,VSelect,VTextField})
